<template>
  <div>
    <nav class="navbar is-primary no_print">
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item">みつけたぞう</router-link>
        <user-status></user-status>
          <a role="button" class="navbar-burger burger" data-target="navMenu" v-on:click="toggleMenu" v-bind:class="{'is-active': isToggleActive}">
          <span></span>
          <span></span>
          <span></span>
        </a>
      </div>
      <div id="navMenu" class="navbar-menu" v-bind:class="{'is-active': isToggleActive}">
        <div class="navbar-start" v-if="hasToken">
          <router-link to="/task/new" class="navbar-item">新規登録</router-link>
          <router-link to="/task/list" class="navbar-item">タスク一覧</router-link>
          <template v-if="modules.module_official_task">
            <router-link to="/official/list" class="navbar-item">一般投稿一覧</router-link>
          </template>
          <router-link to="/settings/urgency" class="navbar-item">プロジェクト設定</router-link>
        </div>
      </div>
      <div class="navbar-end is-hidden-touch">
        <div class="navbar-item">
          <span class="tag is-light">
            V{{ version }}
          </span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import UserStatus from './user_status';
  import { mapState } from 'vuex'

  export default {
    data: function() {
      return {
        isToggleActive: false,
        version: process.env.VUE_APP_PRODUCT_VERSOIN
      }
    },
    methods: {
        toggleMenu: function() {
        this.isToggleActive = !this.isToggleActive;
      }
    },
    watch: {
      '$route' () {
        this.isToggleActive = false;
      }
    },
    components: {
      'user-status': UserStatus,
    },
    computed: {
      ...mapState({
        modules: state => state.auth.modules,
        hasToken: state=> state.auth.hasToken,
      })
    }
  };
</script>